import React, { FC } from 'react'
import { Button, elWFull, useMediaQuery } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'

export interface IChangedRequestActionFooter {
  handlerModalClose: () => void
  isValid: () => boolean
  isSubmitLoading: boolean
  handleSubmitChangeRequest: () => (e?: React.BaseSyntheticEvent) => Promise<void>
}

export const ChangedRequestActionFooter: FC<IChangedRequestActionFooter> = ({
  handlerModalClose,
  isValid,
  isSubmitLoading,
  handleSubmitChangeRequest,
}) => {
  const { isMobile } = useMediaQuery()
  return (
    <ErrorBoundary>
      <>
        {!isMobile && (
          <Button name="submit-cancel" intent="neutral" disabled={isSubmitLoading} onClick={handlerModalClose}>
            Cancel
          </Button>
        )}
        <Button
          role="button"
          name="submit-btn"
          className={isMobile ? elWFull : ''}
          disabled={!isValid() || isSubmitLoading}
          intent="primary"
          onClick={handleSubmitChangeRequest()}
        >
          Log Change
        </Button>
      </>
    </ErrorBoundary>
  )
}
